module.exports = __webpack_public_path__ + "static/media/3.c8165ae6.jpg";